import { Navigate, useLocation } from 'react-router-dom';

/** Keep notifications and saved links useful after reorganizing navigation. */
export function LegacyRedirect({ to, source }: { to: string; source?: string }): JSX.Element {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  if (source) {
    params.set('source', source);
    const payment = params.get('payment');
    if (payment) {
      params.set('id', payment);
      params.set('detailSource', source);
      params.delete('payment');
    }
    const status = params.get('status');
    const statuses: Record<string, string> = {
      PENDING_REVIEW: 'AWAITING_RELEASE',
      UNATTRIBUTED: 'UNATTRIBUTED',
      REQUESTED: 'AWAITING_DECISION',
      APPROVED: source === 'INBOUND' ? 'CREDITED' : 'AWAITING_BANK',
      SENT: 'SENT',
      REJECTED: 'REJECTED',
      FAILED: 'FAILED',
      PENDING: 'AWAITING_DECISION',
    };
    if (status) {
      if (statuses[status]) params.set('status', statuses[status]);
      else params.delete('status');
    }
  }
  return <Navigate to={{ pathname: to, search: params.toString(), hash: location.hash }} replace />;
}
